import { queryKeyPrefix } from 'src/features/tanStackQuery/queryKeyPrefix'

const prefix = queryKeyPrefix.assignPlaceModal

export const queryKeys = {
  places: [...prefix, 'places'] as const,
}
